import en from './en.js'

export default function cr2br(text) {
    return text.replace('\n', '<br>')
}

export {
    en, cr2br,
}